import { filterProps } from "./auth-service-tools173.js";
import "react";
import "./auth-service-tools177.js";

function mergeVars(vars) {
  return vars.reduce((acc, current) => {
    if (current) {
      Object.keys(current).forEach(key => {
        acc[key] = { ...acc[key],
          ...filterProps(current[key])
        };
      });
    }

    return acc;
  }, {});
}

export { mergeVars };